import React from 'react';
import PropTypes from 'prop-types';
import {ButtonWithIcon, HeaderTitle, Divider} from '@/components/atoms';
import DisplayImageUploadField from './DisplayImageUploadField';
import styles from './ActivityGameDisplay.module.scss';

const ActivityImageUploadSection = ({
  title,
  subtitle,
  testId,
  gameData,
  imageFields,
  imageHandlers,
  setShowGuidelines,
  // downloadButtonId = 'download-sample-image-background', // TODO: restore with Download Sample Image
  guidelineButtonId = 'view-guideline-background',
  gridClassName = 'grid grid-cols-3 gap-6',
  // downloadButtonIcon = 'trailing', // TODO: restore with Download Sample Image
  showSectionHeader = true
}) => {
  // TODO: Restore Download Sample Image when sample download is implemented
  // const downloadButtonProps =
  //   downloadButtonIcon === 'leading'
  //     ? {
  //         iconLeading: 'download',
  //         uiSchema: {
  //           title: 'Download Sample Ima...',
  //           variant: 'tertiary',
  //           size: 'small',
  //           isDark: true
  //         }
  //       }
  //     : {
  //         uiSchema: {
  //           title: 'Download Sample Ima...',
  //           variant: 'tertiary',
  //           size: 'small',
  //           isDark: true,
  //           iconTrailing: 'download'
  //         }
  //       };

  return (
    <div
      className='w-full rounded-lg bg-[#1f1f1f] shadow-[0_0_24px_rgba(0,0,0,0.08)]'
      data-testid={testId}>
      {showSectionHeader && (
        <>
          <div className='px-4 py-4'>
            <HeaderTitle
              title={title}
              className='text-[16px] font-bold leading-[22px] text-[#FFFFFF]'
            />
            <p className='-mb-4 text-[14px] font-normal leading-[20px] text-[#DADADA]'>
              {subtitle}
            </p>
          </div>

          <Divider className='mx-3 my-0 border-0 border-b' />
        </>
      )}

      <div className='flex flex-col gap-4 px-4 py-3'>
        <div className='flex items-center gap-4'>
          {/* TODO: Restore Download Sample Image when sample download is implemented
          <ButtonWithIcon
            id={downloadButtonId}
            handleButton={() => {}}
            {...downloadButtonProps}
          />
          */}
          <ButtonWithIcon
            id={guidelineButtonId}
            iconLeading='open_in_full'
            handleButton={() => setShowGuidelines(true)}
            uiSchema={{
              title: 'View Guideline',
              variant: 'tertiary',
              size: 'small',
              isDark: true
            }}
          />
        </div>

        <div className={gridClassName}>
          {imageFields.map((field) => {
            const handler = imageHandlers[field.id] || {};
            return (
              <DisplayImageUploadField
                key={field.id}
                label={field.label}
                imageUri={gameData[field.uriKey]}
                progress={handler.progress}
                validationError={handler.validationError}
                onUpload={handler.onUpload}
                onDelete={handler.onDelete}
                onFileError={handler.onFileError}
                testId={field.uploadTestId}
                validationErrorTestId={field.validationErrorTestId}
                containerClassName={`max-w-[380px] rounded-lg border border-[#4E4E4E] p-3 ${styles.imageUploadContainer}`}
                errorPlacement='inline'
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

const imageFieldShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  uriKey: PropTypes.string.isRequired,
  uploadTestId: PropTypes.string.isRequired,
  validationErrorTestId: PropTypes.string.isRequired
});

const imageHandlerShape = PropTypes.shape({
  onUpload: PropTypes.func,
  onDelete: PropTypes.func,
  onFileError: PropTypes.func,
  progress: PropTypes.number,
  validationError: PropTypes.string
});

ActivityImageUploadSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
  gameData: PropTypes.object.isRequired,
  imageFields: PropTypes.arrayOf(imageFieldShape).isRequired,
  imageHandlers: PropTypes.objectOf(imageHandlerShape).isRequired,
  setShowGuidelines: PropTypes.func.isRequired,
  downloadButtonId: PropTypes.string,
  guidelineButtonId: PropTypes.string,
  gridClassName: PropTypes.string,
  downloadButtonIcon: PropTypes.oneOf(['trailing', 'leading']),
  showSectionHeader: PropTypes.bool
};

export default React.memo(ActivityImageUploadSection);
